import Context from './Context';
import withI18n from './withI18n';
import withConfig from './withConfig';
import withContent from './withContent';
import withLocalStorage from './withLocalStorage';

export default Context;
export {withConfig, withContent, withI18n, withLocalStorage};



// WEBPACK FOOTER //
// ./spa/Components/Context/index.jsx